import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import TextField from "../../Form/TextField";
import CheckboxField from "../../Form/CheckboxField";
import HiddenField from "../../Form/HiddenField";
import SelectField from "../../Form/SelectField";
import TextAreaField from "../../Form/TextAreaField";
import FAIcon from "../../UI/FAIcon/FAIcon";
const START_TIME_MAP = {
    15: [0, 15, 30, 45],
    20: [0, 20, 40],
    30: [0, 15, 30, 45],
    45: [0, 15, 30, 45],
    60: [0, 30],
    90: [0, 30],
};
export const getServiceOfferingRequest = (formState) => {
    var _a, _b, _c;
    return {
        id: formState.id,
        name: formState.name,
        active: formState.active,
        isKeyEngagement: formState.isKeyEngagement,
        description: formState.description,
        meetingLength: (_a = formState.meetingLength) === null || _a === void 0 ? void 0 : _a.value,
        startTimes: ((_b = formState.meetingLength) === null || _b === void 0 ? void 0 : _b.value)
            ? START_TIME_MAP[(_c = formState.meetingLength) === null || _c === void 0 ? void 0 : _c.value]
            : null,
        showStaffNames: !formState.hideStaffNames,
    };
};
const ServiceOfferingForm = () => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: "id" }), _jsx(TextField, { name: "name", label: "Name", required: true }), _jsx(TextAreaField, { name: "description", label: "Description", helpText: "This description will appear in the new version of the meeting scheduler." }), _jsx(SelectField, { name: "meetingLength", label: "Meeting Length (Minutes)", valueKey: "value", options: [15, 20, 30, 45, 60, 90].map((f) => ({
                    label: f,
                    value: f,
                })), helpText: "If no meeting length is specified, this service offering will not appear in the new version of the meeting scheduler." }), _jsx(CheckboxField, { label: "Is Key Engagement", name: "isKeyEngagement" }), _jsx(CheckboxField, { name: "hideStaffNames", label: "Hide Staff Names For This Service", helpText: _jsxs(_Fragment, { children: ["For more information,", " ", _jsxs("a", { href: "https://support.watermarkinsights.com/hc/en-us/articles/11306041979675-Service-Offerings", target: "_blank", title: "Go to help article", rel: "noreferrer", children: ["refer to this help article ", _jsx(FAIcon, { icon: "external-link" })] })] }) }), _jsx(CheckboxField, { name: "active", label: "Active" })] }));
};
export default ServiceOfferingForm;
